import React from 'react';
import { Card, CardContent } from '../ui/card';
import { getServiceIcon } from '../../lib/serviceIcons';

const ServiceTile = ({ service }) => {
  const IconComponent = getServiceIcon(service.icon);

  return (
    <Card className="border-2 hover:border-blue-300 transition-all hover:shadow-lg">
      <CardContent className="p-8 space-y-4">
        <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center">
          <IconComponent className="w-8 h-8 text-blue-600" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
        <p className="text-gray-600 leading-relaxed">{service.description}</p>
      </CardContent>
    </Card>
  );
};

export default ServiceTile;
